module.exports = __webpack_public_path__ + "img/teacher-divider.6839d0c3.svg";